<template>
    <div class="about-text-box">
        <h2>Our company</h2>
        <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus,
            quae illo sint dolor, blanditiis a molestias accusantium impedit
            quisquam eum, eius assumenda. Doloremque ratione magnam provident
            aliquid veniam illum consequatur!
        </p>
    </div>
</template>

<script>
    export default {
        name: "AboutText",
    };
</script>

<style lang="scss" scoped>
    .about-text-box {
        width: 40%;
        height: 40%;
    }
</style>
